import { $ } from '@zimpa/dom';

const CONTAINER_SELECTOR = '.js-cookie-bar';
const ACCEPT_SELECTOR = '.js-cookie-accept';
const REJECT_SELECTOR = '.js-cookie-reject';

export function cookieBar(): void {
    const container = $(CONTAINER_SELECTOR);
    const accept = $(ACCEPT_SELECTOR);
    const reject = $(REJECT_SELECTOR);

    if (
        container === undefined ||
        accept === undefined ||
        reject === undefined
    ) {
        return;
    }

    function setCookie(val: boolean) {
        const date = new Date();
        date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);

        document.cookie = `allow-cookies=${val}; expires=${date.toUTCString()}; path=/; Secure`;

        container?.parentNode?.removeChild(container);
    }

    accept.addEventListener('click', (): void => {
        setCookie(true);
    });

    reject.addEventListener('click', (): void => {
        setCookie(false);
    });
}
